import cache from "@/libs/cache";
export default {
  title: process.env.VUE_APP_TITLE,
  token: cache.get(cache.CACHE_KEY.TOKEN),
  userInfo: cache.get(cache.CACHE_KEY.USERINFO),
  calculateRole: false,
  role: null,
  redictRouter: null,
  dict: {},
  dictAll: {}
};
